/**
 * paymentHelpers.js
 * Constantes e funções utilitárias compartilhadas pela seção de pagamento.
 */

export const NFSE_STATUS = {
  pending:    { label: 'Não emitida',      color: '#9ca3af' },
  queued:     { label: 'Na fila',          color: '#f59e0b' },
  processing: { label: 'Em processamento', color: '#3b82f6' },
  issued:     { label: 'Emitida',          color: '#16a34a' },
  error:      { label: 'Erro',             color: '#ef4444' },
  canceled:   { label: 'Cancelada',        color: '#6b7280' },
};

export function fmtDateTime(str) {
  if (!str) return null;
  try {
    const d = new Date(str.replace(' ', 'T'));
    return (
      `${String(d.getDate()).padStart(2, '0')}/` +
      `${String(d.getMonth() + 1).padStart(2, '0')}/` +
      `${d.getFullYear()} às ` +
      `${String(d.getHours()).padStart(2, '0')}:` +
      `${String(d.getMinutes()).padStart(2, '0')}`
    );
  } catch {
    return str;
  }
}

export function fmtDate(str) {
  if (!str) return null;
  try {
    const d = new Date(str.replace(' ', 'T'));
    return (
      `${String(d.getDate()).padStart(2, '0')}/` +
      `${String(d.getMonth() + 1).padStart(2, '0')}/` +
      `${d.getFullYear()}`
    );
  } catch {
    return str;
  }
}
